import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {ReactComponent as _PWLogo}  from './../Resources/img_pw-logo.svg';
import {ReactComponent as _Facebook} from './../Resources/ic_facebook.svg';
import {ReactComponent as Instagram} from './../Resources/ic_instagram.svg';
import {ReactComponent as LinkedIn} from './../Resources/ic_linkedin.svg';
import {ReactComponent as X} from './../Resources/ic_x.svg';
import {ReactComponent as YouTube} from './../Resources/ic_youtube.svg';



const Container = styled.header`
    display: flex;
    flex-direction: row;
    box-shadow: 0px 6px 4px rgba(0, 0, 0, 0.25);
    height: 140px;
    width: 100vw;
    z-index: 100000;
    flex-shrink: 0;
    @media (min-width: 768px) and (max-width: 1025px) {
       min-height: 112px;
       height: 112px;
    }
    @media (min-width: 319px) and (max-width: 481px) {
       min-height: 168px;
       align-items: center;
    }
`;

const PWLogo = styled(_PWLogo)`
    cursor: pointer;
    margin-left: 20px;
    @media (min-width: 319px) and (max-width: 481px){
        flex-basis: 100%;
        margin-bottom: 18px;
        height: 50px;
    }
    @media (min-width: 319px) and (max-width: 1439px){
        margin-left: unset;
    }
`;
const Facebook = styled(_Facebook)`
    cursor: pointer;
    margin-left: auto;
    @media (min-width: 319px) and (max-width: 481px) {
        margin-left: 0px;
    }
`;

const Centered = styled.div`
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    gap: 10px;
    align-items: center;

    max-width: 1440px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 60px;
    padding-right: 100px;
    box-sizing: border-box;         /* Opera/IE 8+ */

    -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
    -moz-box-sizing: border-box;    /* Firefox, other Gecko */
    @media (min-width: 319px) and (max-width: 481px) {
        flex-grow: 0;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        padding-left: 0px;
        padding-right: 0px;
        gap: 10px;
    }
    @media (min-width: 768px) and (max-width: 1025px) {
       min-height: 112px;
       padding-left: 20px;
    }
    @media (min-width: 481px) and (max-width: 1360px){
        padding-left: 20px;
    }
`;

export default class Header extends Component {
    navigate = (url, stay) =>{
        if(stay){
        window.location.href = '/';
        }else{
            window.open(url,'_blank').focus();
        }
    }
    render(){
       
        return (<Container>
            <Centered style={{}}>
                <PWLogo width={240} height={53} onClick={() => this.navigate(null, true)}  />
                <Facebook onClick={()=> this.navigate('https://www.facebook.com/phunware/')}/>
                <X style={{cursor: 'pointer'}} onClick={()=> this.navigate('https://x.com/phunware')}/>
                <Instagram style={{cursor: 'pointer'}} onClick={()=> this.navigate('https://www.instagram.com/phunware/#')}/>
                <LinkedIn style={{cursor: 'pointer'}} onClick={()=> this.navigate('https://www.linkedin.com/company/phunware/')} />
                <YouTube style={{cursor: 'pointer'}} onClick={()=> this.navigate('https://www.youtube.com/c/phunwareofficial')} />
            </Centered>
        </Container>);
    }
}
